export var largeBreakpointValue = "large";
export var paddingSpace = 2;
export var backgroundColor = "backgroundLight";